export const FRAMES_ARE_LOADING = 'FRAMES_ARE_LOADING'
export const FRAMES_LOADED = 'FRAMES_LOADED'
export const FRAMES_FAILED = 'FRAMES_FAILED'

export const CURRENT_FRAME_SIZE = 'CURRENT_FRAME_SIZE'



// WEBPACK FOOTER //
// ./src/constants/framesActions.js